module.exports = __webpack_public_path__ + "img/4c65858.jpg";